import { render, staticRenderFns } from "./CopilotAnnotation.vue?vue&type=template&id=10d4340a"
import script from "./CopilotAnnotation.vue?vue&type=script&lang=ts"
export * from "./CopilotAnnotation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports